<script lang="ts" setup>
import { ContactHealthScoreStats } from '@/types/metrics/ContactHealthScore';
import { getContactHealthScoreStatus } from '@/utils/contactHealthScore';

interface Props {
    healthScore: ContactHealthScoreStats | null;
}

const props = defineProps<Props>();
const healthScore = props.healthScore?.score ?? 59;
const circumference = 2 * Math.PI * 42;
const dash = (healthScore / 100) * circumference;

const scoreColor = (score: number) => {
    if (score >= 70) return 'text-success';
    if (score >= 45) return 'text-warning';
    return 'text-danger';
};
</script>
<template>
    <div class="flex flex-col gap-6 md:flex-row md:items-start">
        <div class="flex items-center gap-4">
            <div class="relative h-28 w-28">
                <svg viewBox="0 0 100 100" class="h-28 w-28 -rotate-90">
                    <circle
                        class="stroke-gray-200"
                        cx="50"
                        cy="50"
                        r="42"
                        fill="none"
                        stroke="var(--border)"
                        stroke-width="8"
                    />
                    <circle
                        cx="50"
                        cy="50"
                        r="42"
                        fill="none"
                        :class="scoreColor(healthScore)"
                        stroke="currentColor"
                        stroke-linecap="round"
                        stroke-width="8"
                        :stroke-dasharray="`${dash} ${circumference}`"
                    />
                </svg>
                <div class="absolute inset-0 flex flex-col items-center justify-center">
                    <span class="text-foreground text-2xl font-semibold leading-none">{{
                        healthScore
                    }}</span>
                    <span class="text-muted-foreground mt-1 text-[10px] uppercase tracking-wider">
                        health
                    </span>
                </div>
            </div>
            <div>
                <p class="text-lg font-semibold" :class="scoreColor(healthScore)">
                    {{
                        $t(
                            'contact.timeline.stats.healthScore.' +
                                getContactHealthScoreStatus(healthScore),
                        )
                    }}
                </p>
            </div>
        </div>
    </div>
</template>
